(function() {
    'use strict';

    var isMobileWidth = false;

    /*
    function determineMobileWidth(){
      isMobileWidth = ($(window).width() < 1024);
    }
    */

    /*
    function handle_search_location(){
      console.log('something');
      if(!isMobileWidth){
        var search =  $('#searchbox-2'),
            social = $('.footer-social');

        search.clone().prependTo('#mm-main-nav').show();

        social.clone().appendTo('#mm-menu-main-nav .mm-listview');
      } else {
        // Nothing.  Leave it as is.
      }
    };
    */
    var search = $('#searchbox-2'),
        social = $('.footer-social');
    search
        .clone()
        .prependTo('#mm-main-nav')
        .show();
    social.clone().appendTo('#mm-menu-main-nav .mm-listview');

    // Responsive images
    function resizeImages() {
        // Responsive background image
        $('.responsive-bg').each(function() {
            var desktop = $(this).attr('data-d'),
                tablet = $(this).attr('data-t'),
                mobile = $(this).attr('data-m');
            if ($(window).width() < 767) {
                $(this).attr(
                    'style',
                    'background-image: url("' + mobile + '")'
                );
            } else if ($(window).width() < 1023) {
                $(this).attr(
                    'style',
                    'background-image: url("' + tablet + '")'
                );
            } else {
                $(this).attr(
                    'style',
                    'background-image: url("' + desktop + '")'
                );
            }
        });

        // Responsive Image
        $('.responsive-img').each(function() {
            var desktop = $(this).attr('data-d'),
                tablet = $(this).attr('data-t'),
                mobile = $(this).attr('data-m');
            if ($(window).width() < 767) {
                $(this).attr('src', mobile);
            } else if ($(window).width() < 1023) {
                $(this).attr('src', tablet);
            } else {
                $(this).attr('src', desktop);
            }
        });
    }

    function handle_login() {
        $('#login').on({
            click: function() {
                $('#login .login-container').addClass('active');
            },
        });

        $('#close').on({
            click: function(e) {
                e.stopPropagation();
                $('#login .login-container').removeClass('active');
            },
        });
    }

    // Do stuff on document ready
    $(document).ready(function() {
        resizeImages();
        handle_login();
    });

    $(window).on({
        // Do stuff on Window resize
        resize: function() {
            if ($(window).width() < 1024) {
                resizeImages();
            }

            //determineMobileWidth();
            //handle_search_location();
        },

        // Do stuff on Window scroll
        scroll: function() {},
    });
})();
